<template>
    <v-carousel
    height="100vh">
    <v-carousel-item
      src="../assets/image1.jpg"
    ></v-carousel-item>
    <v-carousel-item
      src="../assets/image5.jpg"
    ></v-carousel-item>
    <v-carousel-item
      src="../assets/image6.jpg"
    ></v-carousel-item>
    <v-carousel-item
      src="../assets/image8.webp"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
    name:"Carousel",
}
</script>